// extracted by mini-css-extract-plugin
module.exports = {"footer":"EpSearchFooter_footer__neuvA","footer__link":"EpSearchFooter_footer__link__nfxXW"};